<template>
	<section class="page page-place-revision" v-bind:key="venueModel">
		<ViewVenueDetailForm
			v-bind:venueModel="venueModel"
			v-if="venueModel.uniqueKey"
			v-on:submit="Handle_OnSubmitRevision"
		/>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component } from 'vue-property-decorator';
	import { mounted } from '@/Utility/Decorators';

	/**
	 * Page controller for venue revision editing. Fetches venue data
	 * and delegates form presentation to ViewVenueDetailForm.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PagePlaceRevision extends PageBase {
		/**
		 * The venue model being revised
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		protected venueModel: ChalkySticks.Model.Venue = ChalkySticks.Factory.Venue.model();

		/**
		 * The revision model for submitting changes
		 *
		 * @type ChalkySticks.Model.Venue
		 */
		protected venueRevisionModel: ChalkySticks.Model.Venue = ChalkySticks.Factory.Venue.model();

		/**
		 * Fetch venue data on mount.
		 *
		 * @return Promise<void>
		 */
		@mounted
		protected async setup(): Promise<void> {
			this.venueModel.set({
				id: this.$route.params.id,
			});

			// Fetch venue model
			await this.venueModel.fetch();

			// Change endpoint
			this.venueRevisionModel.setEndpoint('venue-revisions');
			this.venueRevisionModel.id = this.venueModel.id;

			// Redirect to 404
			if (!this.venueModel?.id) {
				this.$router.push({
					path: '/not-found',
				});
			}
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * Handles the form submission for venue revision.
		 * Treats 409 Conflict as success.
		 *
		 * @param ChalkySticks.Model.Venue venueModel
		 * @return Promise<void>
		 */
		protected async Handle_OnSubmitRevision(venueModel: ChalkySticks.Model.Venue): Promise<void> {
			this.venueRevisionModel.set(venueModel.attributes);

			try {
				await this.venueRevisionModel.save();
			} catch (error: any) {
				// If the error is a 409 Conflict, treat as success
				if (error && (error.code === 409 || error.status === 409)) {
					console.info('409 Conflict received, treating as success.');
					return;
				}

				throw error;
			}
		}

		// endregion: Event Handlers
	}
</script>
